module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.6.3 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/checker.html"
    }
  }, [_vm._v("Checker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support prop:radio-required #2004")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/checklist.html"
    }
  }, [_vm._v("Checklist")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] now on-change params has labels as second param #2018")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/previewer.html"
    }
  }, [_vm._v("Previewer")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix method name starts with _ will get vue(2.4.4) warning #2001")]), _vm._v(" "), _c('li', [_vm._v("[feature] add method:getCurrentIndex")]), _vm._v(" "), _c('li', [_vm._v("[feature] add slot:button-before slot:button-after")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/search.html"
    }
  }, [_vm._v("Search")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] add event:on-blur")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/toast.html"
    }
  }, [_vm._v("Toast")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix no padding when using slot and type === text")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-input.html"
    }
  }, [_vm._v("XInput")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] toast error when clicking error icon #2009")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0efd1078", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-0efd1078"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.6.3-125.vue
// module id = 2033
// module chunks = 259